import React, { useEffect } from "react";
import NavbarTop from "../components/global/NavbarTop";
import CompanyContent from "../components/Company/CompanyContent";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../redux/language/selector";

const Company = () => {
  const { t } = useTranslation();
  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("company-page.title");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <>
      <NavbarTop />
      <CompanyContent />
    </>
  );
};

export default Company;
